import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
    if (import.meta.env.DEV) {
        console.warn('Supabase credentials missing in .env.local');
    }
}

export const supabase = createClient(supabaseUrl || '', supabaseAnonKey || '');

/**
 * Helper to get the base URL of the application for auth redirects.
 * Works for both localhost and production (Vercel, etc.)
 */
export const getURL = () => {
    let url =
        import.meta.env.VITE_SITE_URL ?? // Custom site URL (optional)
        import.meta.env.VITE_VERCEL_URL ?? // Automatically set by Vercel (optional)
        window.location.origin; // Fallback to current browser origin

    // Make sure to include `https://` when not localhost
    url = url.includes('http') ? url : `https://${url}`;
    // Make sure up to date with current origin if trailing slash is missing or extra
    return url.charAt(url.length - 1) === '/' ? url : `${url}/`;
};
